import React from 'react';
import GridRow from "../../../../components/common/GridRow";
import GridColumn from "../../../../components/common/GridColumn";
import PropTypes from "prop-types";
import ActivitiesPrintView from "./ActivitiesPrintView";

const QuarterlyScheduleOfDeliverablesPrintView = ({actions, dateRangeType, htmlReportInfo}) => {
    if (!htmlReportInfo)
        return null;

    const handleFileDownload = (fileId) => {
        actions.downloadFile(fileId);
    };

    return <section>
        <header className={`report-header`}>
            <h1>Bureau of Exceptional Education and Student Services,<br/>Florida Department of Education</h1>
            <h2>{htmlReportInfo.datesCovered} Quarterly Schedule of Deliverables Report</h2>
        </header>

        <GridRow>
            <GridColumn medium={`6`}>
                <b>IDEA Funded State Project:</b> {htmlReportInfo.projectName}
            </GridColumn>
            <GridColumn medium={`6`}>
                <b>Fiscal Agent:</b> {htmlReportInfo.programFiscalAgent.fiscalAgentName}
            </GridColumn>
        </GridRow>
        <GridRow>
            <GridColumn medium={`6`}>
                <b>Project Number:</b> {htmlReportInfo.projectNumbers}
            </GridColumn>
            <GridColumn medium={`6`}>
                <b>TAPS:</b> {htmlReportInfo.tapsCodes}
            </GridColumn>
        </GridRow>
        <GridRow>
            <GridColumn medium={`6`}>
                <b>Project Manager:</b> {htmlReportInfo.projectManagerNames}
            </GridColumn>
            <GridColumn medium={`6`}>
                <b>BEESS Liaison:</b> {htmlReportInfo.doeProjectLiaison.fullName}
            </GridColumn>
        </GridRow>
        <GridRow>
            <GridColumn medium={`6`}>
                <b>Project Dates:</b> {htmlReportInfo.projectStartDateOutput} - {htmlReportInfo.projectEndDateOutput}
            </GridColumn>
            <GridColumn medium={`6`}>
                <b>Award Amount:</b> {htmlReportInfo.budgetTotalDisplay}
            </GridColumn>
        </GridRow>

        <ActivitiesPrintView activities={htmlReportInfo.trainings} activityLabel={`TRAINING`} dateRangeType={dateRangeType} handleFileDownload={handleFileDownload} />

        <ActivitiesPrintView activities={htmlReportInfo.products} activityLabel={`PRODUCT`} dateRangeType={dateRangeType} handleFileDownload={handleFileDownload} />

        <ActivitiesPrintView activities={htmlReportInfo.services} activityLabel={`SERVICE DELIVERY`} dateRangeType={dateRangeType} handleFileDownload={handleFileDownload} />
    </section>;
};

QuarterlyScheduleOfDeliverablesPrintView.propTypes = {
    actions: PropTypes.object.isRequired,
    dateRangeType: PropTypes.string,
    htmlReportInfo: PropTypes.object,
};

export default QuarterlyScheduleOfDeliverablesPrintView;